'use client';
import { useEffect, useState, useRef } from 'react';
 import Icon from'@/components/ui/AppIcon';

interface Stat {
  id: string
  value: string
  label: string
  icon: 'CheckBadgeIcon' | 'StarIcon' | 'MapPinIcon' | 'ClockIcon'
  suffix?: string
}

const stats: Stat[] = [
  {
    id: 'stat_rides',
    value: '5',
    label: 'Scooter Rides',
    icon: 'CheckBadgeIcon',
    suffix: 'M+',
  },
  {
    id: 'stat_rating',
    value: '4.9',
    label: 'Average Rating',
    icon: 'StarIcon',
    suffix: '★',
  },
  {
    id: 'stat_cities',
    value: '50',
    label: 'Cities Worldwide',
    icon: 'MapPinIcon',
    suffix: '+',
  },
  {
    id: 'stat_support',
    value: '24/7',
    label: 'Customer Support',
    icon: 'ClockIcon',
  },
]

export default function TrustStats() {
  const [isVisible, setIsVisible] = useState(false)
  const sectionRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true)
        }
      },
      { threshold: 0.2 }
    )

    if (sectionRef.current) {
      observer.observe(sectionRef.current)
    }

    return () => observer.disconnect()
  }, [])

  return (
    <section
      ref={sectionRef}
      className="py-20 bg-gradient-to-b from-white to-muted/30"
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <div
              key={stat.id}
              className={`text-center space-y-3 ${
                isVisible ? 'count-up' : 'opacity-0'
              }`}
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-secondary/10 mb-2">
                <Icon
                  name={stat.icon}
                  variant="solid"
                  size={28}
                  className="text-secondary"
                />
              </div>
              <p className="text-4xl md:text-5xl font-display font-bold text-primary">
                {stat.value}
                {stat.suffix && (
                  <span className="text-accent">{stat.suffix}</span>
                )}
              </p>
              <p className="text-sm font-body text-muted-foreground font-medium">
                {stat.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}